import { capitalize } from 'lodash'
import React, { FC, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { RouteComponentProps } from 'react-router-dom'
import routes from 'src/routes'
import { setPageTitle, setPreviousPage } from '../../../ducks/onDemand'
import { ListItem } from '../AbstractList/ListItem'

export const BbsPosters = [
  {
    id: 928,
    title: 'BONE MARROW ASPIRATE CONCENTRATE AND PLATELET RICH PLASMA COMBINATION EFFECT IN RABBIT ARTICULAR CARTILAGE DEFECT TREATMENT',
    presenting_author_name: 'Nabillah binti Abd Radzak',
    poster: 'https://moa-2022.s3.ap-southeast-1.amazonaws.com/BBS_01.pdf',
  },
  {
    id: 1057,
    title: 'CHARACTERIZATION OF OSTEOARTHRITIC SYNOVIUM AND SYNOVIAL-DERIVED FIBROBLASTS IN RELATION TO OBESITY',
    presenting_author_name: 'CHIEW CHIAW LEE',
    poster: 'https://moa-2022.s3.ap-southeast-1.amazonaws.com/BBS_02.pdf',
  },
  {
    id: 1031,
    title: 'SYNOVIAL FLUID-DERIVED EXOSOMAL-PIRNAS AS BIOMARKERS FOR OSTEOARTHRITIS',
    presenting_author_name: 'Goh Tuan Xin',
    poster: 'https://moa-2022.s3.ap-southeast-1.amazonaws.com/BBS_03.pdf',
  },
  {
    id: 785,
    title: 'INTRA-ARTICULAR INJECTIONS OF PERIPHERAL BLOOD MESENCHYMAL STROMAL CELLS AND PLATELET-RICH PLASMA PROMOTES SUPERIOR FULL-THICKNESS CARTILAGE DEFECT STUDIES IN RABBITS',
    presenting_author_name: 'Rufaidah Binti Othman',
    poster: 'https://moa-2022.s3.ap-southeast-1.amazonaws.com/BBS_04.pdf',
  },
  {
    id: 509,
    title: 'HUMAN ADIPOSE DERIVED MESENCHYMAL STROMAL CELLS PROLIFERATION AND COLLAGEN PRODUCTION BY ADIPONECTIN MODULATION',
    presenting_author_name: 'Krishnan SHR',
    poster: 'https://moa-2022.s3.ap-southeast-1.amazonaws.com/BBS_05.pdf',
  },
]

export const BestBasicScience: FC<RouteComponentProps> = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setPageTitle('Best Basic Science Award'))
    dispatch(setPreviousPage(routes.onDemand))
  }, [dispatch])

  return (
    <div>
      {BbsPosters.map((poster) => {
        return <ListItem key={poster.id} abstractType="bbs" title={poster.title} subtitle={capitalize(poster.presenting_author_name)} abstractId={poster.id} />
      })}
    </div>
  )
}
